import React, { useState, useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ITEMS_PER_PAGE = 10; // Linhas aguentam mais dados
const COLORS = {
  primary: "#0078d4", // Azul
  secondary: "#f7630c", // Laranja (contraste bom para linhas)
  grid: "#e1dfdd",
  text: "#605e5c"
};

const LineChartComponent = ({ data, chartLabel, dataKeys }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const formatYAxis = (value) => new Intl.NumberFormat("pt-BR").format(value);
  const formatXAxis = (value) => typeof value === 'string' ? value.replace('Semana ', 'S') : value;

  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);
  const isPaginated = totalPages > 1;

  if (currentPage >= totalPages && totalPages > 0) { setCurrentPage(totalPages - 1); }

  const visibleData = useMemo(() => {
      if (!isPaginated) return data;
      const start = currentPage * ITEMS_PER_PAGE;
      const end = start + ITEMS_PER_PAGE;
      return data.slice(start, end);
  }, [data, currentPage, isPaginated]);

  return (
    <div className="d-flex flex-column align-items-center w-100 bg-white rounded p-2">
        <ResponsiveContainer width="100%" height={400}>
        <LineChart data={visibleData} margin={{ top: 20, right: 30, left: 10, bottom: 50 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={COLORS.grid} />
            
            <XAxis 
                dataKey="DESCRICAO1" 
                interval={0}
                tickFormatter={formatXAxis}
                tick={{ fontSize: 12, fill: COLORS.text, angle: -45, textAnchor: 'end' }}
                height={60}
                axisLine={{ stroke: COLORS.grid }}
                tickLine={false}
            />
            
            <YAxis tickFormatter={formatYAxis} tick={{ fontSize: 12, fill: COLORS.text }} axisLine={false} tickLine={false} />
            
            <Tooltip 
                formatter={(value) => new Intl.NumberFormat("pt-BR").format(value)}
                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }} 
            />
            <Legend verticalAlign="top" height={36} iconType="plainline" />
            
            {/* Linhas mais grossas e suaves */}
            {dataKeys[0] && (
            <Line type="monotone" dataKey={dataKeys[0]} stroke={COLORS.primary} name={chartLabel[0]} strokeWidth={3} dot={{ r: 4, strokeWidth: 0, fill: COLORS.primary }} activeDot={{ r: 7 }} />
            )}
            
            {dataKeys[1] && (
            <Line type="monotone" dataKey={dataKeys[1]} stroke={COLORS.secondary} name={chartLabel[1]} strokeWidth={3} dot={{ r: 4, strokeWidth: 0, fill: COLORS.secondary }} activeDot={{ r: 7 }} />
            )}
        </LineChart>
        </ResponsiveContainer>

        {isPaginated && (
            <div className="d-flex justify-content-center align-items-center mt-2 gap-2">
                <button className="btn btn-sm btn-light border" onClick={() => setCurrentPage(p => Math.max(0, p - 1))} disabled={currentPage === 0}>←</button>
                <span className="small text-muted fw-bold">Pág {currentPage + 1}/{totalPages}</span>
                <button className="btn btn-sm btn-light border" onClick={() => setCurrentPage(p => Math.min(totalPages - 1, p + 1))} disabled={currentPage === totalPages - 1}>→</button>
            </div>
        )}
    </div>
  );
};

export default LineChartComponent;